import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	title: {
		fontWeight: "bolder"
	}
})

export default useStyles
